import { normalizeUserRole } from './role-access'

/**
 * FF-3636. 'unknown' is a real answer: a user matching no portal has nowhere to be sent, and
 * redirecting them instead of signing them out loops them between portals.
 */
export type PortalMembership = 'backoffice' | 'partner' | 'merchant' | 'unknown'

export interface PortalProfile {
  userRole?: string | null
  entityType?: string | null
  entityId?: string | null
}

const BACKOFFICE_ROLES = ['backoffice.admin', 'platform_admin']

const normalizeEntityType = (entityType?: string | null): string => (entityType || '').trim().toLowerCase()

/**
 * Duplicated verbatim across the three portals; they share no package. entityType is lowercased to
 * stay symmetric with usePartner/useMerchant, which already do.
 */
export function classifyPortalMembership(profile?: PortalProfile | null): PortalMembership {
  if (!profile) return 'unknown'

  const entityType = normalizeEntityType(profile.entityType)

  // A backoffice role that carries an entity is treated as that entity's user.
  if (!profile.entityId && BACKOFFICE_ROLES.includes(normalizeUserRole(profile.userRole))) {
    return 'backoffice'
  }

  if (entityType === 'partner') return 'partner'
  if (entityType === 'merchant') return 'merchant'

  return 'unknown'
}
